import React, { createContext, useContext, useState, useEffect, useRef } from "react"
import { registerPushNotification } from "../api/Cards"
import { useUser } from "../contexts/UserContext"

export const EventNotificationContext = createContext(null)
export const useEventNotifications = () => useContext(EventNotificationContext)

export const EventNotifications = ({ children }) => {


    var state = {};

    const token = useRef(null)

    /**
     addNotification({
                title:  getPrefix(data[i]) +  " " + data[i].Title,
                subtitle: '',
                message: data[i].Message,
                theme: 'darkblue',
                duration: 50000,
                native: true // when using native, your OS will handle theming.
            });
     */


    function urlB64ToUint8Array(base64String) {
        var padding = '='.repeat((4 - base64String.length % 4) % 4);
        var base64 = (base64String + padding)
            .replace(/\-/g, '+')
            .replace(/_/g, '/');

        var rawData = window.atob(base64);
        var outputArray = new Uint8Array(rawData.length);

        for (var i = 0; i < rawData.length; ++i) {
            outputArray[i] = rawData.charCodeAt(i);
        }
        return outputArray;
    }

    function base64Encode(arrayBuffer) {
        return btoa(String.fromCharCode.apply(null, new Uint8Array(arrayBuffer)));
    }

    function handleSWRegistration(reg) {
        // Are Notifications supported in the service worker?
        if (!(reg.showNotification)) {
            return;
        }

        // Check if push messaging is supported
        if (!('PushManager' in window)) {
            return;
        }

        //Once the service worker is ready, we check whether a subscription already exists since before, in which case
        navigator.serviceWorker.ready.then(function (reg) {
           
            reg.pushManager.getSubscription()
                .then(async function (subscription) {
                    if (subscription != null) {
                        state.isSubscribed = true;
                        state.subscription = subscription;

                        var p256dh = base64Encode(subscription.getKey('p256dh'));
                        var auth = base64Encode(subscription.getKey('auth'));

                        var pushNotification = { PushEndpoint: subscription.endpoint, PushP256DH: p256dh, PushAuth: auth };
                        var pushNotificationContainer = { Subscription: pushNotification, Token: token.current };
                        //Send subscription data to backend
                        var result = await registerPushNotification(pushNotificationContainer)
                    }
                    else
                        subscribe();
                    
                });
        });
    }

    function initializeServiceWorker() {
        if ('serviceWorker' in navigator) 
            navigator.serviceWorker.register(window.location.origin.toString() + "/service-worker.js").then(handleSWRegistration);
        
    }

    function subscribe() {
        navigator.serviceWorker.ready.then(function (reg) {
            var subscribeParams = { userVisibleOnly: true };

            //Setting the public key of our VAPID key pair.
            var applicationServerKey = urlB64ToUint8Array("BGsOJRUxLHCMIM0_Y2Hk_XwYR-r44d83ZvB_Vd77W0zKSrADXo0plgY5v2uhsztkiEtpBPSqANA5LR34gzx6S4Q");
            subscribeParams.applicationServerKey = applicationServerKey;

            reg.pushManager.subscribe(subscribeParams)
                .then(async function (subscription) {
                    state.isSubscribed = true;

                    var p256dh = base64Encode(subscription.getKey('p256dh'));
                    var auth = base64Encode(subscription.getKey('auth'));

                    var pushNotification = { PushEndpoint: subscription.endpoint, PushP256DH: p256dh, PushAuth: auth };
                    var pushNotificationContainer = { Subscription: pushNotification, Token: token.current };

                    state.subscription = subscription;
                    //Send subscription data to backend
                    var result = await registerPushNotification(pushNotificationContainer)
                    if (typeof data === "number") {
                        console.log("Failed to send subscription to backend!\n");
                    }
                });
        });
    }

    //setup handles the push notification subscriptions.
    //If a user has previously selected to have push notifications,
    //we ensure that they automatically get re-subscribed if the previous subscription expires.
    const setup = (usertoken) => {

        token.current = usertoken
        //Request permission for push notifications
        Notification.requestPermission().then(function (status) {
            if (status === 'denied') {
                state.permissionDenied = true;
            } else if (status === 'granted') {
                state.permissionDenied = false;
                initializeServiceWorker();
            }
        });

//        if(!state.isSubscribed)
 //           subscribe();
        
    }
        const returnItems = { setup }
        return <EventNotificationContext.Provider value={returnItems}>{children}</EventNotificationContext.Provider>
}

export default EventNotifications
